/* eslint-disable */
import React, { useEffect, useState } from "react";
// import { Stack, Form, Col, Row, Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  appUserActivity,
  deleteAppUserEmails,
} from "../../../redux/actions/crmActions";
import "../Leadtabs.css";
import { useParams } from "react-router";
import moment from "moment";
import * as Icon from "react-bootstrap-icons";
// import DeleteModal from "../../../../../shared/DeleteModal";

const DetailedHistory = (props) => {
  const { id } = useParams();
  const { authToken } = props;
  const { contactId } = props;

  const [deleteId, SetDeleteId] = useState(0);
  const [filledLength, setfilledLength] = useState(0);
  const [dltDialog, SetDltDialog] = useState(false);
  const [activeCards, setActiveCards] = useState([]);
  const userDetails = useSelector((state) => state.crmLeads.userActivityDetails);


  const uName = userDetails?.data?.response?.name

  const dispatch = useDispatch();

  // const userDetails = useSelector((state) => state.crmLeads.userActivityDetails);
  useEffect(() => {
        if(props.item?.prompt_data?.length > 0){
            props.item?.prompt_data?.map((data) => {
                if (data.counter_data.length > 0) {
                    setfilledLength(data?.counter_data?.length);
                }
            })
        } 
  }, []);
    
  const dates = new Date();

  const getDate = (date) => {
    if (date !== "" && date !== null && date !== "0000-00-00 00:00:00") {
      let d = moment(date).format("DD");
      return d;
    }
  };

  const getMonth = (date) => {
    if (date !== "" && date !== null && date !== "0000-00-00 00:00:00") {
      const dates = new Date();
      let m = moment(date).format("MMM");
      return m.toUpperCase();
    }
  };

  const deleteEmail = () => {
    let idd = id !== undefined ? id : contactId.contact_ids[0].contact_id;
    SetDeleteId(0);
    SetDltDialog(false);
    dispatch(deleteAppUserEmails(authToken, [deleteId], idd));
  };

  const hideDialog = () => {
    SetDeleteId(0);
    SetDltDialog(false);
  };

  const openModal = (val) => {
    SetDeleteId(val.id);
    SetDltDialog(true);
  };

    return (
        <div className="m-2 grid grid-cols-12  py-4 pe-5" key={props.item.prompt_id}>
            <div key={props.index} className="p-1 col-span-2">
                <div className="fs-6 fw-bold email-status-date">
                <strong>{getDate(props.item?.prompt_date)}</strong> <br />{" "}
                <span>{getMonth(props.item?.prompt_date)}</span>
                </div>
            </div>
            <div className="col-span-10" style={{ backgroundColor: "#fff" }}>
                <div className="grid grid-cols-12 p-2 lh-base">
                <div className="col-span-10 max-sm:col-span-9">
                    <div className="status-title flex">
                    <Icon.Display className="my-auto" />
                    &nbsp;
                    <strong className="ms-1 capitalize max-sm:leading-5 my-auto">
                        {uName} visited the website
                    </strong>
                    </div>
                </div>
                <div className="col-span-2 max-sm:col-span-3 my-auto">
                    <div className="expandButton mx-auto"
                    onClick={() => {
                        if (activeCards.includes(props.item.prompt_id)) {
                        setActiveCards(
                            activeCards.filter((id) => id !== props.item.prompt_id)
                        );
                        } else {
                        setActiveCards([...activeCards, props.item.prompt_id]);
                        }
                    }}
                    >
                    {activeCards.includes(props.item.prompt_id) ? "Collapse" : "Expand"} 
                    </div>
                </div>
                </div>
                <div className="px-4 ms-2 d-flex flex-column">
                {activeCards.includes(props.item.prompt_id) ? <div className="greyText">Actions Taken</div> : <div className="greyText">Summary</div>}
                <div className="darkBlackText my-1">{props.item?.prompt_time}{", "}{props.item?.prompt_date}</div>
                <div className="my-1 pb-3">
                    <div className="darkBlackText">{props.item?.prompt_count} prompt(s) entered</div>
                    <div className="darkBlackText">{props.item?.answer_count} replie(s) given</div>
                    <div className="darkBlackText">{props.item?.counter_data_count} field(s) filled</div>
                </div>

                {activeCards?.includes(props.item.prompt_id) && <> 
                    {props.item?.prompt_data?.map((pItem, i) => {
                    return (
                        <>
                        {pItem?.prompt !== "" && <> 
                            <div className="greyText my-1">{uName} Prompted</div>
                            <div className="blackText pb-3">{pItem?.prompt}</div>
                        </>}
                        {pItem?.answer !== "" && <>
                            <div className="greyText my-1">ChatBot Replied</div>
                            <div className="blackText pb-3">{pItem?.answer}</div>
                        </>}
                        {pItem.counter_data.length > 0 && pItem.counter_data.map((c_q,c_index) => {
                            return (
                            <>
                                <div className="greyText my-1">chatbot asked counter-question</div >
                                <div className="blackText pb-2">“{ c_q.question }”</div>  
                                <div className="flex status-title my-auto pb-3" style={{alignItems:"end"}}>
                                <Icon.FileEarmarkText className="mb-1 bg-white"/>
                                &nbsp;
                                <strong className="capitalize ms-1 mt-1 my-auto">
                                    Field {c_q.label}
                                </strong>
                                </div>
                                { c_q?.counter_answer !=="" && <>
                                    <div className="greyText my-1">{uName} filled field {c_q.label}</div>
                                    <div className="blackText pb-3">{c_q?.counter_answer}</div>
                                </>
                                }
                            </>
                            )
                        })}
                        </>
                    );
                    })}
                </>}
                </div>
            </div>
        </div>
    )
};

export default DetailedHistory;